function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.793 15.658a7.527 7.527 0 0 0 1.597.171c.525 0 1.045-.053 1.554-.158 2.622-.363 5.178-1.638 7.517-3.455 1.688-1.311 2.952-2.624 3.674-3.53a.873.873 0 0 0 0-1.088c-.722-.906-1.985-2.218-3.674-3.53C19.644 1.88 16.57.5 13.412.5h-.022l-.055.002c-3.132.023-6.181 1.399-8.971 3.566C2.675 5.38 1.41 6.692.69 7.598a.873.873 0 0 0 0 1.088c.721.906 1.985 2.219 3.674 3.53 2.299 1.786 4.815 3.051 7.43 3.442zM2.436 7.144a23.89 23.89 0 0 1 2.541-2.286c2.636-2.047 5.498-3.338 8.375-3.356.03 0 .036-.001.045-.002h.019c2.895.001 5.775 1.294 8.432 3.358.94.73 1.792 1.509 2.54 2.286.408.423.713.77.9.998a17.72 17.72 0 0 1-.9.998c-.748.777-1.6 1.556-2.54 2.286-2.213 1.719-4.62 2.92-7.074 3.26a6.676 6.676 0 0 1-2.8-.011c-2.452-.368-4.822-1.56-6.997-3.249a23.883 23.883 0 0 1-2.54-2.286 17.72 17.72 0 0 1-.9-.998c.187-.229.492-.575.9-.998z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.99 8.181c0-2.52-2.053-4.57-4.577-4.57a4.579 4.579 0 0 0-4.577 4.57c0 2.52 2.053 4.57 4.577 4.57a4.579 4.579 0 0 0 4.577-4.57zm-4.577 3.678a3.686 3.686 0 0 1-3.686-3.678 3.686 3.686 0 0 1 7.371 0 3.686 3.686 0 0 1-3.685 3.678z"
});

var SvgEyeIcon = function SvgEyeIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 16,
    viewBox: "0 0 27 16",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.color,
    fillRule: "nonzero"
  }, _ref2, _ref3));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye_icon.a3ad88ec.svg";
export { ForwardRef as ReactComponent };